import { render } from "./module-type-editor.vue?vue&type=template&id=48f30f03&scoped=true"
import script from "./module-type-editor.vue?vue&type=script&lang=js"
export * from "./module-type-editor.vue?vue&type=script&lang=js"

import "./module-type-editor.vue?vue&type=style&index=0&id=48f30f03&scoped=true&lang=css"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f30f03"]])

export default __exports__